import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function TermsAndConditions() {
  const location = useLocation();
  const navigate = useNavigate();
  const fromItem = location.state?.fromItem;

  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <div className="mb-6">
        {fromItem && (
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="text-blue-500 hover:text-blue-700"
          >
            &larr; Retour à l'article
          </button>
        )}
      </div>
      <h1 className="text-3xl font-bold mb-8 text-center text-blue-800">
        Conditions Générales
      </h1>
      <div className="prose max-w-none bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-xl font-semibold mb-3 pb-2 border-b-2 border-blue-200 text-blue-700">
          Organisation
        </h2>
        <p className="mb-5 text-gray-700 leading-relaxed">
          Cette enchère est organisée au profit d'une association caritative. La
          participation implique l'acceptation entière et sans réserve des
          présentes conditions.
        </p>

        <h2 className="text-xl font-semibold mb-3 pb-2 border-b-2 border-blue-200 text-blue-700">
          Dates de l'enchère
        </h2>
        <p className="mb-5 text-gray-700 leading-relaxed">
          L'enchère débute le 21/04 à 10h00 et se termine le 27/04 à 18h00.
        </p>

        <h2 className="text-xl font-semibold mb-3 pb-2 border-b-2 border-blue-200 text-blue-700">
          Modalités de participation
        </h2>
        <p className="mb-5 text-gray-700 leading-relaxed">
          Chaque participant place une enchère en indiquant clairement son
          numéro de téléphone. En enchérissant, le participant s'engage
          formellement à honorer son offre s'il remporte l'enchère.
        </p>

        <h2 className="text-xl font-semibold mb-3 pb-2 border-b-2 border-blue-200 text-blue-700">
          Extension du temps d'enchère
        </h2>
        <p className="mb-5 text-gray-700 leading-relaxed">
          Afin d'assurer une expérience équitable pour tous les participants, si
          une enchère est placée alors qu'il reste moins de 2 minutes avant la
          fin prévue de l'enchère, le temps restant sera automatiquement
          prolongé de 2 minutes à partir du moment de l'enchère. Cette règle
          empêche le "sniping" (enchères de dernière minute) et donne à tous les
          participants une chance équitable de répondre aux enchères tardives.
        </p>

        <h2 className="text-xl font-semibold mb-3 pb-2 border-b-2 border-blue-200 text-blue-700">
          Détermination du gagnant
        </h2>
        <p className="mb-5 text-gray-700 leading-relaxed">
          À l'issue de l'enchère, le participant ayant placé la plus haute offre
          est déclaré gagnant. Il sera contacté par téléphone afin d'organiser
          la remise du lot et le paiement.
        </p>

        <h2 className="text-xl font-semibold mb-3 pb-2 border-b-2 border-blue-200 text-blue-700">
          Délai d'engagement
        </h2>
        <p className="mb-5 text-gray-700 leading-relaxed">
          Le gagnant dispose d'un délai de 48 heures après notification pour
          honorer son engagement. Passé ce délai, le second plus haut
          enchérisseur sera déclaré vainqueur, et ainsi de suite jusqu'à
          réalisation de l'engagement.
        </p>

        <h2 className="text-xl font-semibold mb-3 pb-2 border-b-2 border-blue-200 text-blue-700">
          Responsabilité
        </h2>
        <p className="mb-5 text-gray-700 leading-relaxed">
          Les organisateurs déclinent toute responsabilité en cas
          d'impossibilité de joindre un participant ou en cas de non-respect de
          l'engagement par un participant.
        </p>

        <h2 className="text-xl font-semibold mb-3 pb-2 border-b-2 border-blue-200 text-blue-700">
          Traitement des données personnelles
        </h2>
        <p className="mb-5 text-gray-700 leading-relaxed">
          Vos données personnelles (numéro de téléphone) sont collectées
          uniquement dans le cadre de cette enchère afin d'identifier et
          contacter les participants et gagnants. Ces données seront traitées de
          manière confidentielle et sécurisée, conformément au Règlement Général
          sur la Protection des Données (RGPD). Elles ne seront en aucun cas
          transmises à des tiers, sauf obligations légales. À la fin de
          l'événement et après le règlement complet des enchères, vos données
          personnelles seront supprimées sous un délai maximum de 30 jours.
        </p>
        <p className="mb-5 text-gray-700 leading-relaxed">
          Pour exercer vos droits d'accès, de rectification, de suppression ou
          pour toute question relative au traitement de vos données, veuillez
          nous contacter à l'adresse fournie par les organisateurs.
        </p>
      </div>
    </div>
  );
}
